export default __webpack_public_path__ + "static/media/link-url-tutorial.71663d70.png";